<template>
  <v-container>
    <v-switch
      @change="showToggleDialog()"
      v-if="!footer"
      hide-details="auto"
      class="mt-0"
      value
      v-model="item.user.isActive"
      color="primary"
    ></v-switch>
    <span v-else>{{ item.user.isActive ? "true" : "false" }}</span>
    <v-dialog persistent v-model="toggleDialog" max-width="450">
      <v-card class="pb-4">
        <v-card-title class="primary--text"></v-card-title>
        <v-card-text class=""> Do you want to change status ?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            class="font-weight-bold"
            text
            @click="closeDialog()"
            >{{ $t("common.no") }}</v-btn
          >
          <v-btn
            color="error"
            class="font-weight-bold"
            text
            :loading="toggleBtnLoading"
            @click="updateStatus()"
            >Yes, Change</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { changeLandlordStatus } from "../methods/change_landlord_status";
export default {
  props: {
    item: Object,
    footer: Boolean
  },
  methods: {
    showToggleDialog() {
      this.toggleDialog = true;
      this.selectedItem = !this.item?.user?.isActive;
    },
    closeDialog() {
      this.toggleDialog = false;
      this.item.user.isActive = this.selectedItem;
    },
    updateStatus() {
      this.toggleBtnLoading = true;
      changeLandlordStatus({
        id: this.item._id,
        status: this.item.user.isActive
      }).then(({ data }) => {
        this.toggleBtnLoading = false;
        if (data.changeLandlordStatus) {
          this.$root.$emit("snackbar", {
            snackbar: true,
            text: "Landlord Status Changed Successfully",
            color: "green"
          });
          this.toggleDialog = false;
          this.$root.$emit("refetchLandlord");
        }
      });
    }
  },
  data() {
    return {
      toggleDialog: false,
      toggleBtnLoading: false,
      selectedItem: {}
    };
  }
};
</script>
